import React from 'react'
import PropTypes from 'prop-types'
import Styles from './index.scss'

const SetStatus = props => (
  <div>
    {
      props.status.value === props.statusList.onReview.value
        ? <form
          onSubmit={props.submitStatus(
            props.portfolio,
            props.portfolio.selected,
            props.userId,
            props.statusList,
            props.product)}
        >
          <p>Set service status</p>
          <div className="mt-radio-list">
            <label htmlFor="approve" className="mt-radio mt-radio-outline"> Approve
              <input
                onChange={props.handleStatus(props.statusList)}
                required
                type="radio"
                value="approved"
                id="approve"
                name="status"
                checked={props.portfolio.selected.status === props.statusList.approved.value}
              />
              <span />
            </label>
            <label htmlFor="reject" className="mt-radio mt-radio-outline"> Reject
              <input
                onChange={props.handleStatus(props.statusList)}
                required
                type="radio"
                value="rejected"
                id="reject"
                name="status"
                checked={props.portfolio.selected.status === props.statusList.rejected.value}
              />
              <span />
            </label>
          </div>
          {
            props.portfolio.selected.status === props.statusList.rejected.value
            ? (
              <div>
                <textarea
                  className="form-control"
                  required
                  rows="3"
                  placeholder="Reject Reason"
                  name="rejectReason"
                  value={props.portfolio.selected.rejectReason}
                  onChange={props.handleInputChange()}
                />
              </div>
            )
            : null
          }
          <div className={Styles['form-actions']}>
            <div className="row">
              <div className="col-md-offset-3 col-md-9">
                <button type="submit" name="submit" className={Styles['btn-submit']}>Submit</button>
              </div>
            </div>
          </div>
        </form>
      : props.status.label
    }
  </div>
)

SetStatus.defaultProps = {
  status: {
    value: -1,
  },
}

SetStatus.propTypes = {
  submitStatus: PropTypes.func.isRequired,
  handleStatus: PropTypes.func.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  product: PropTypes.shape({
    status: PropTypes.number.isRequired,
  }).isRequired,
  portfolio: PropTypes.shape({
    selected: PropTypes.shape({
      status: PropTypes.number.isRequired,
      rejectReason: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  statusList: PropTypes.shape({
    approved: PropTypes.shape({
      value: PropTypes.number.isRequired,
    }).isRequired,
    rejected: PropTypes.shape({
      value: PropTypes.number.isRequired,
    }).isRequired,
    onReview: PropTypes.shape({
      value: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
  status: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.number,
  }),
  userId: PropTypes.string.isRequired,
}

export default SetStatus
